export default function checkIfEmptyString(str: string) {
  if (str.trim() === '') {
    return true;
  } else {
    return false;
  }
}
